import React, { useEffect } from 'react';

import { Pagination } from '@material-ui/lab';
import usePagination from 'app/shared/components/desktop/pagination/pagination';


const PaginationComp = ({data,listPage,emptySearch,setListPage}) => {
    

     
  const PER_PAGE = 5;

  const count = Math.ceil(data?.length / PER_PAGE);
  const _DATA = usePagination(data, PER_PAGE);
    useEffect(() => {

        _DATA.jump(listPage);
    
      },[listPage, _DATA, emptySearch])
    
      const handleChange = (e, p) => {
        setListPage(p)
      };

    return (
        <> 
          <Pagination
          className={'paginationTab'}
          count={count}
          page={listPage}
          onChange={handleChange}
          color="primary"
          showFirstButton
          showLastButton
        />
        </>
    )
}

export default PaginationComp;